import { useEffect, useState } from "react";
import { Avatar, Button, Col, Flex, Row, Space, Table, Tag, Tooltip, Typography } from "antd";
import { EditOutlined, FacebookFilled, InstagramOutlined } from "@ant-design/icons";
import { callGetDashboardWinners } from "../../../../services/winnersService";
import { showNotificationTopEnd } from "../../../../util/utils";
import WinnersModalSteps from "../WinnersModalSteps/WinnersModalSteps";
import { DASHBOARD_WINNERS } from "../../../../constants/AppConstants";

const { Title } = Typography;

export default function WinnersList() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [reload, setReload] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    useEffect(() => {
        getWinners(pagination.current - 1, pagination.pageSize);
        // eslint-disable-next-line
    }, [reload]);


    const handleTableChange = (pagination) => {
        getWinners(pagination.current - 1, pagination.pageSize);
    };


    const getWinners = async (page, size) => {
        setLoading(true);

        const response = await callGetDashboardWinners(page, size);
        if (response?.status === 200) {
            setData(response.data.content);
            setPagination({
                current: page + 1,
                pageSize: size,
                total: response.data?.page?.totalElements,
            });
        } else {
            showNotificationTopEnd("error", "Error, por favor recarga la pagina");
        }
        setLoading(false);
    };


    const handleEdit = (record) => {
        setSelectedRecord(record);
        setModalVisible(true);
    };


    const columns = [
        {
            title: DASHBOARD_WINNERS.COLUMNS.LOTTO_ID,
            dataIndex: "lottoId",
            key: "lottoId",
            width: 100,
        },
        {
            title: DASHBOARD_WINNERS.COLUMNS.LOTTO_TITLE,
            //render: (record) => record.lotto.title,
            dataIndex: ["lotto", "title"],
            key: "title",
        },
        {
            title: DASHBOARD_WINNERS.COLUMNS.LOTTO_AWARD,
            key: "awards",
            render: (record) => {
                const firstPlace = record.lotto.awards.find(a => a.place === "1ER LUGAR");
                return firstPlace ? firstPlace.award : "-";
            },
        },
        {
            title: DASHBOARD_WINNERS.COLUMNS.STATUS,
            dataIndex: ["lotto", "status"],
            key: "status",
            render: (value) => {
                switch (value) {
                    case DASHBOARD_WINNERS.STATUS.COMPLETED:
                        return <Tag color="green">{DASHBOARD_WINNERS.STATUS.COMPLETED}</Tag>;
                    case DASHBOARD_WINNERS.STATUS.CLOSED:
                        return <Tag color="lime">{DASHBOARD_WINNERS.STATUS.CLOSED}</Tag>;
                    default:
                        return <Tag color="gold">{DASHBOARD_WINNERS.STATUS.PENDING}</Tag>;
                }
            },
        },
        {
            title: DASHBOARD_WINNERS.COLUMNS.SOCIAL_LINKS,
            key: "socialLinks",
            render: (record) => {
                return (
                    <div style={{ display: "flex", gap: "8px" }}>
                        <a href={record.facebookLink} target="_blank" rel="noopener noreferrer">
                            <Avatar
                                style={{ backgroundColor: "#1877F2" }}
                                icon={<FacebookFilled />}
                            />
                        </a>
                        <a href={record.instagramLink} target="_blank" rel="noopener noreferrer">
                            <Avatar
                                style={{ backgroundColor: "#E1306C" }}
                                icon={<InstagramOutlined />}
                            />
                        </a>
                    </div>
                );
            },
        },
        {
            title: DASHBOARD_WINNERS.COLUMNS.ACTIONS,
            key: "actions",
            render: (_, record) => (
                <Space>
                    <Tooltip title={DASHBOARD_WINNERS.ACTIONS.TOOLTIPS.EDIT}>
                        <Button
                            shape="circle"
                            icon={<EditOutlined />}
                            type="primary"
                            onClick={() => handleEdit(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];


    return (
        <Flex vertical>
            <Row
                gutter={[16, 16]}
                justify="space-between"
                align="middle"
                style={{ marginBottom: 24 }}
            >
                <Col span="auto">
                    <Title level={3}>{DASHBOARD_WINNERS.TITLE}</Title>
                </Col>
                <Col span="auto">
                    <Button
                        color="green"
                        variant="solid"
                        onClick={() => setModalVisible(true)}
                    >
                        {DASHBOARD_WINNERS.ACTIONS.CREATE_TITLE}
                    </Button>
                    <WinnersModalSteps
                        visible={modalVisible}
                        onClose={() => {
                            setModalVisible(false);
                            setSelectedRecord(null);
                            setReload(!reload);
                        }}
                        selectedRecord={selectedRecord}
                    />
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="lottoId"
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
            />
        </Flex>
    );
}